/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarketComparablePayload } from '../models/MarketComparablePayload';
import type { MarketComparableResponse } from '../models/MarketComparableResponse';
import type { MarketFilters } from '../models/MarketFilters';
import type { MarketSearchResponse } from '../models/MarketSearchResponse';
import type { MarketStatsQuery } from '../models/MarketStatsQuery';
import type { MarketStatsResponse } from '../models/MarketStatsResponse';
import type { PropertySearchResponse } from '../models/PropertySearchResponse';
import type { SimplePropertyDetailsResponse } from '../models/SimplePropertyDetailsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MarketService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Find census tracts that are similar to the given census tract in terms of demographics
     * and housing characteristics.
     * @param requestBody
     * @returns MarketComparableResponse The market comparables.
     * @throws ApiError
     */
    public marketComparables(
        requestBody: MarketComparablePayload,
    ): CancelablePromise<Array<MarketComparableResponse>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market/comparables',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get market statistics for given property characteristics (number of units, year built, etc.)
     * Returns the number of properties, the number of units, the average unit mix, and amenity frequencies.
     * @param requestBody Property characteristics.
     * @returns MarketStatsResponse The market statistics.
     * @throws ApiError
     */
    public marketStatistics(
        requestBody: {
            subject: MarketStatsQuery;
        },
    ): CancelablePromise<MarketStatsResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market/statistics',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public internalMarketSearch(
        requestBody: MarketFilters,
    ): CancelablePromise<{
        properties: Array<SimplePropertyDetailsResponse>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market/internal_search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Performs a market-level search using flexible geometric shapes and high-level filters.
     * This allows for comprehensive analysis of market data within specified boundaries.
     *
     * Each request is limited to a maximum of 2,500 results. If you hit this limit, consider refining your filters
     * to narrow the search and reduce the result count.
     *
     * The search includes filters such as year built, number of units, number of stories, and geographic boundaries
     * (defined by coordinates).
     * @param requestBody
     * @returns any A list of properties that match the specified search criteria.
     * @throws ApiError
     */
    public marketSearch(
        requestBody: MarketFilters,
    ): CancelablePromise<{
        properties: Array<PropertySearchResponse>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/market/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param q
     * @returns MarketSearchResponse Ok
     * @throws ApiError
     */
    public shapeSearch(
        q: string,
    ): CancelablePromise<Array<MarketSearchResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/market/shape_search',
            query: {
                'q': q,
            },
        });
    }
}
